export function galleryFade(): void {
    const items = document.querySelectorAll<HTMLElement>('.gallery__item');
    if (!items.length) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('gallery__item--visible');
                    observer.unobserve(entry.target);
                }
            });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0.1 },
    );

    items.forEach((item) => observer.observe(item));
}
